import React from 'react';
import { Cake } from 'lucide-react';
import './UpcomingBirthdays.css';

const MONTH_NAMES = [
  '', 'January', 'February', 'March', 'April', 'May', 'June',
  'July', 'August', 'September', 'October', 'November', 'December',
];

function UpcomingBirthdays({ birthdays, loading, timeframe }) {
  const timeframeLabels = {
    today: 'today',
    week: 'this week',
    month: 'this month',
  };

  if (loading) {
    return (
      <div className="upcoming-birthdays">
        <div className="upcoming-birthdays-header">
          <Cake size={16} strokeWidth={2} />
          <h3>Upcoming Birthdays</h3>
        </div>
        <div className="upcoming-birthdays-loading">Loading...</div>
      </div>
    );
  }

  return (
    <div className="upcoming-birthdays">
      <div className="upcoming-birthdays-header">
        <Cake size={16} strokeWidth={2} />
        <h3>Upcoming Birthdays</h3>
        {birthdays && birthdays.length > 0 && (
          <span className="upcoming-birthdays-count">{birthdays.length}</span>
        )}
      </div>

      {(!birthdays || birthdays.length === 0) ? (
        <div className="upcoming-birthdays-empty">
          No upcoming birthdays {timeframeLabels[timeframe] || 'this month'}
        </div>
      ) : (
        <div className="upcoming-birthdays-list">
          {birthdays.map((person) => {
            const displayName = person.first_name && person.last_name
              ? `${person.first_name} ${person.last_name}`
              : person.name;
            const monthName = MONTH_NAMES[person.birthday_month] || '';
            const dateStr = `${monthName} ${person.birthday_day}`;

            return (
              <div key={person.id} className="upcoming-birthday-item">
                <div className="upcoming-birthday-icon">
                  <Cake size={14} />
                </div>
                <div className="upcoming-birthday-info">
                  <span className="upcoming-birthday-name">{displayName}</span>
                  <span className="upcoming-birthday-date">{dateStr}</span>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}

export default UpcomingBirthdays;
